import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "@/app/App.tsx";
import { TooltipProvider } from "@/design-system/primitives/tooltip";
import "@/app/app.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing from index.html");

createRoot(root).render(
  <StrictMode>
    {/* One provider for the whole app: every hint shares its enter delay, and
        the skip window lets a neighbouring hint open without re-waiting. */}
    <TooltipProvider>
      <App />
    </TooltipProvider>
  </StrictMode>,
);
